declare global {
	interface Window {
		kam001_real_estate_blocks_globals: {
			config: {
				supabasePublishableKey: string;
				// Legacy alias, kept in sync with supabasePublishableKey by the backend.
				supabaseAnonKey: string;
				supabaseUrl: string;
				registrationUrl: string;
				loginSectionUrl: string;
				estatePage: string;
				premiumSuchprofilePage: string;
				filterEstateGroups: string[];
				/** true on project microsites (Projektseiten), false on the main site. */
				isProjectPage: boolean;
				/** Gravity Forms ID for single-estate contact inquiries (optional). */
				estateContactFormId?: number | null;
			};
		};
	}
}

const globalData = {
	...window.kam001_real_estate_blocks_globals,
};

export default globalData;
